const DEPRECATED_TIMEZONE_ALIASES = {
    'Asia/Kolkata': 'Asia/Calcutta',
    'Europe/Kiev': 'Europe/Kyiv',
};

const getTimeZonesForRegion = (code) => {
    const locale = new Intl.Locale(`en-${code}`);

    return locale.getTimeZones?.() ?? locale.timeZones;
};

const isTimezoneLookupSupported = () => {
    try {
        const zones = getTimeZonesForRegion('US');

        return Array.isArray(zones) && zones.length > 0;
    } catch {
        return false;
    }
};

const getCountryCodeFromTimezone = (timeZone, validCodes) => {
    if (!timeZone || timeZone.startsWith('Etc/')) {
        return null;
    }

    const resolved = DEPRECATED_TIMEZONE_ALIASES[timeZone] ?? timeZone;

    for (const code of validCodes) {
        const zones = getTimeZonesForRegion(code);

        if (zones?.includes(resolved)) {
            return code;
        }
    }

    return null;
};

const getCountryCodeFromLanguage = (validCodes) => {
    const language = navigator.language || navigator.userLanguage;

    if (!language?.includes('-')) {
        return null;
    }

    const code = language.split('-')[1].toUpperCase();

    return validCodes.has(code) ? code : null;
};

export function detectCountryCode(validCodes) {
    if (isTimezoneLookupSupported()) {
        const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
        const fromTimezone = getCountryCodeFromTimezone(timeZone, validCodes);

        if (fromTimezone) {
            return fromTimezone;
        }
    }

    return getCountryCodeFromLanguage(validCodes);
}
